import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link, useLocation } from "react-router-dom";
import statWarsLogo from "../../../assets/images/StatWars-Logo.png";
import { trimPath } from "../../utilities";

const menuRoutes = [
  // {
  //   path: "/bet-monitor",
  //   name: 'Bet Monitor'
  // },
  {
    path: "/",
    name: "Event Management",
  },
  // {
  //   path: "/event-week-management/nfl",
  //   name: "Event Management (NFL)",
  // },
  // {
  //   path: "/data-lookup",
  //   name: "Data Lookup",
  // },
  {
    path: "/player-index/5DB88974-FA00-4A02-8EC2-5753A3BD0D2C",
    name: "Player Index",
  },
  {
    path: "/price-rules/5DB88974-FA00-4A02-8EC2-5753A3BD0D2C",
    name: "Price rules",
  },
  // {
  //   path: "/operator-settings/bluebet",
  //   name: "Operator Settings"
  // },
];

const Menu = (props) => {
  const classes = useStyles();
  const { drawerOpen } = props;
  const location = useLocation();

  const [clickCount, setClickCount] = useState(0);

  const handleClick = () => {
    setClickCount(clickCount + 1);
  };
  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      open={drawerOpen}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHeader}>
        <div className={classes.logo}>
          <Link to="/">
            {clickCount > 10 ? (
              "STATE WARS UNLOCKED"
            ) : (
              <img src={statWarsLogo} alt="logo" />
            )}
          </Link>
          <Typography
            variant="caption"
            style={{ color: "#ddd" }}
            onClick={() => handleClick()}
          >
            1.5.10
          </Typography>
        </div>
      </div>
      <List className={classes.linkList}>
        {menuRoutes.map((route) => (
          <ListItem
            key={route.path}
            component={Link}
            to={route.path}
            button
            className={classes.listItem}
            selected={
              route.path === "/"
                ? location.pathname.includes("event-management")
                : trimPath(location.pathname) === trimPath(route.path)
            }
          >
            <ListItemText primary={route.name} />
          </ListItem>
        ))}
        {clickCount > 10 && (
          <ListItem
            key={"state-wars"}
            component={Link}
            to={"/state-wars"}
            button
            className={classes.listItem}
            selected={trimPath(location.pathname) === trimPath("/state-wars")}
          >
            <ListItemText primary={"States Wars"} />
          </ListItem>
        )}
      </List>
    </Drawer>
  );
};

export default Menu;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: theme.layout.drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: theme.layout.drawerWidth,
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  drawerHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  logo: {
    width: "140px",
    marginRight: "auto",
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    position: "relative",
    "& img": {
      width: "100%",
    },
    "& >  span": {
      position: "absolute",
      left: "100%",
      top: "-8px",
      marginLeft: "8px",
    },
  },
  linkList: {
    "& .MuiTypography-body1": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    "& .MuiListItem-gutters": {
      paddingLeft: theme.spacing(3),
    },
    "& .Mui-selected": {
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: `${theme.palette.common.black}15`,
    },
  },
}));
